import { AppointmentModel } from '../../models/appointment';

import { Appointment } from './types';

const cancelledStatuses = ['no_show', 'rescheduled'];

export const convertJaneDataToAppointmentModel = (
  data: Appointment,
): AppointmentModel => {
  const { patient } = data;
  const state = data.state ?? '';

  const appointmentModel: AppointmentModel = {
    externalId: `${data.id}`,
    externalPatientId: data.patient_id ? `${data.patient_id}` : undefined,
    firstName: patient?.first_name ?? '',
    lastName: patient?.last_name ?? '',
    startTime: data.start_at,
    endTime: data.end_at ?? '',
    name: data.treatment_name ?? '',
    description: data.notes_text ?? '',
    rawEhrData: data,
    status: data.cancelled ? 'CANCELLED' : undefined,
    isArchived: Boolean(data.archived_at) || cancelledStatuses.includes(state),
    // Do not import appointments that are missing patient
    isImportable:
      Boolean(data.patient_id) && !cancelledStatuses.includes(state),
    sessionType: data.treatment_name ?? undefined,
  };

  return appointmentModel;
};
